import React, { useState } from 'react'
import styles from './LeadQualityScreen.module.css'
import LeadQualityDoughnutChart from './LeadQualityDoughnutChat'
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LeadSummaryDataInsufficientComponent from './LeadSummaryDataInsufficientComponent';
import CenteredPopUp from '../../Components/CenteredPopUp/CenteredPopUp';
import LeadRecommendationPopupContent from './LeadRecommendationPopupContent';

interface LeadSummaryStatusUpdateCardComponentProps {
    data: any,
}

const LeadSummaryStatusUpdateCardComponent: React.FC<LeadSummaryStatusUpdateCardComponentProps> = ({ data }) => {
    const [openReadMore, setOpenReadMore] = useState<boolean>(false);
    const readMoreHandler  = () => {
        document.body.classList.add("no-overflow");
        setOpenReadMore(true)
    }
    let leadCallingScoreType = data?.leadCallingScoreType ? data.leadCallingScoreType.toLowerCase() : "";
    return (
        <div className={styles.LqscsCard}>
            <div className={styles.LqscsCardHeader}>
                <div className={styles.LqscsCardTitle}>{data.cardTitle}</div>
                <div className={styles.LqscsCardSubTitle}>{data.cardSubtitle}</div>
            </div>
            {
                (data.report_display === "N") ?
                    <LeadSummaryDataInsufficientComponent
                        leadHighlightText={data.thresholdDesc}
                        infoBannerText="Updating lead status helps you in generating better reports for insights"
                        data={data}
                    />
                    :
                    <div className={styles.LqscsCardBody}>
                        <div className={styles.LqscsCardBodyLeft}>
                            <div>
                            <LeadQualityDoughnutChart totalLeads={data.statusnotUpdated} leadgetCall={data.statusupdated} backgrounds={["#279ea0", "#f197a2"]} labels={['Not Updated', 'Updated']} />
                            </div>
                            <div className={styles.LqscsCallingDatabox}>
                                <div className={styles.LqscsCallData}>
                                    <div className={`${styles.LqscsCallDataValue} ${styles.LqscsCallDataValueP}`}>{data.statusnotUpdated}</div>
                                    <div className={styles.LqscsCallDataLabel}>Not Updated</div>
                                </div>
                                <div className={styles.LqscsCallData}>
                                    <div className={`${styles.LqscsCallDataValue} ${styles.LqscsCallDataValueG}`}>{data.statusupdated}</div>
                                    <div className={styles.LqscsCallDataLabel}>Updated</div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.LqscsCardBodyRight}>
                            <div className={styles.LqscsPercentageInfo}>
                                <div className={styles.LqscsPercentageData}>
                                    <div className={styles.LqscsPercentageDataVal}>{data.leadCalledPercent}</div>
                                    <div className={styles.LqscsPercentageDataLabel}>Leads Called</div>
                                </div>
                                <div className={styles.LqscsScroreType}>
                                    <div className={`${styles.LqscsTitleTag} ${styles[leadCallingScoreType]}`}>{leadCallingScoreType}</div>
                                    {(leadCallingScoreType !== "moderate") && <div className={`${styles.LqscsScroreTypeTxt} ${styles[leadCallingScoreType]}`}>Among {(leadCallingScoreType == "good") && "Top"} {(leadCallingScoreType == "poor") && "Bottom"} 20%</div>}
                                </div>
                            </div>
                            <div className={styles.LqscsHighlight}>Top agents in your city update status for {data.topBenchmark} of their leads.</div>
                            <div className={`${styles.LqscsBanner} ${styles[leadCallingScoreType]}`}>
                                <span className={`${styles.LqscsBannerIcon} ${styles[leadCallingScoreType]}`}>
                                    {(leadCallingScoreType == "good") && <ThumbUpIcon className={styles.ThumbUpIcon} />}
                                    {(leadCallingScoreType == "moderate") && <InfoOutlinedIcon className={styles.infoIcon} />}
                                    {(leadCallingScoreType == "poor") && <InfoOutlinedIcon className={styles.infoIcon} />}
                                </span>
                                {
                                    data.leadCallingScoreMessage
                                    // (leadCallingScoreType == "good") ? "Updating lead status helps you in generating better reports for insights"
                                    //     :
                                    //     (leadCallingScoreType == "moderate") ? "Updating lead status helps you in generating better reports for insights"
                                    //         :
                                    //         (leadCallingScoreType == "poor") ? "Updating lead status helps you in generating better reports for insights"
                                    //             :
                                    //             ""
                                }
                                <span className={styles.ReadMoreCta} onClick={readMoreHandler}>Read More</span>
                            </div>
                        </div>
                    </div>
            }
            {
                openReadMore && <CenteredPopUp
                    setModal={setOpenReadMore}
                    children={
                        <LeadRecommendationPopupContent 
                        title={"Status Updates"}
                        subtext={"This Indicates the % of leads whose status was updated after a call."}
                        recommendation={"Updating lead status on time helps you track leads better and minimize losses. Also, it helps the system to analyse and evaluate lead qualification for any necessary adjustments."}
                        scoreType={leadCallingScoreType}
                        />
                    }
                    modiferClass={styles.LcqModal}
                    closeIcon={true}
                    closeClassMofifier={styles.LcqModalClose}
                />
            }
        </div>
    )
}

export default LeadSummaryStatusUpdateCardComponent